
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const treatments = state => state.treatments;
const getsingle = state => param =>state.treatments.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  treatments,
  getsingle
};